// http请求封装
var http = {};
http.quest = function (option, callback) {
  var url = option.url;
  var method = option.method;
  // var header = option.header;
  var data = option.data;
  var timeout = option.timeout || 0;
  var xhr = new XMLHttpRequest();
  timeout > 0 && (xhr.timeout = timeout);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status >= 200 && xhr.status < 400) {
        var result = xhr.responseText;
        try {
          result = JSON.parse(xhr.responseText);
        } catch (e) {
          /* empty */
        }
        callback && callback(null, result);
      } else {
        callback && callback("status: " + xhr.status);
      }
    }
  };
  xhr.open(method, url, true);
  if (typeof data === "object") {
    try {
      data = JSON.stringify(data);
    } catch (e) {
      /* empty */
    }
  }
  xhr.send(data);
  xhr.ontimeout = function () {
    callback && callback("timeout");
  };
};
http.get = function (url) {
  var option = url.url ? url : { url: url };
  option.method = "get";
  return new Promise((resolve, reject) => {
    this.quest(option, (err, res) => {
      if (err) {
        reject(err);
      } else {
        resolve(res);
      }
    });
  });
};
http.post = function (option) {
  option.method = "post";
  return new Promise((resolve, reject) => {
    this.quest(option, (err, res) => {
      if (err) {
        reject(err);
      } else {
        resolve(res);
      }
    });
  });
};
http.proxy = function (option) {
  const data = window.btoa(JSON.stringify(option));
  const url =
    "https://service-61g1benb-1251732481.cd.apigw.tencentcs.com/release/getResource";
  return http.post({ url, data });
};

export default http;
